import React, { Component } from 'react';

class Tab2 extends Component {
	render() {
		return (
			<div className="columns" id="faq">
				<div className="section column">
					<div className="content faq-content">
						<div className="columns">
							<div className="column ">
								<h4>Ketentuan Layanan</h4>
								<h5>Ketentuan Penggunaan</h5>
								<p>
									{' '}
									Dengan mengunduh, memasang, dan/atau menggunakan Aplikasi DELIV ("Aplikasi"), Anda
									setuju bahwa Anda telah membaca, memahami dan menerima dan menyetujui Ketentuan
									Penggunaan ini ("Ketentuan Penggunaan"). Ketentuan Penggunaan ini merupakan suatu
									perjanjian sah antara Anda dan PT Deliv Technologies dan Layanan dan Aplikasi
									(sebagaimana didefinisikan di bawah ini) berlaku pada kunjungan dan penggunaan Anda
									pada situs web kami di www.deliv.co.id ("Situs web"). Silahkan membatalkan akun Anda
									(jika Anda telah mendaftar untuk Aplikasi) dan secara permanen menghapus aplikasi
									dari perangkat Anda jika Anda tidak setuju atau tidak ingin masuk ke dalam Ketentuan
									Penggunaan. MOHON ANDA MEMERIKSA KETENTUAN PENGGUNAAN DAN KEBIJAKAN PRIVASI KAMI
									DENGAN SEKSAMA SEBELUM MENGUNDUH APLIKASI ATAU MENGGUNAKAN LAYANAN KAMI UNTUK
									PERTAMA KALI.
								</p>

								<h5>Hal-hal Umum</h5>
								<ol type="1">
									<li>
										PT Deliv Technologies adalah suatu perseroan yang didirikan berdasarkan hukum
										Negara Republik Indonesia ("kami" atau "milik kami").
									</li>
									<li>
										Aplikasi ini merupakan aplikasi perangkat lunak yang berfungsi sebagai sarana
										untuk menemukan layanan dengan menggunakan sepeda motor yang disediakan oleh
										pihak ketiga (pengemudi ojek) ("Penyedia(-penyedia) Layanan"). Aplikasi ini
										menawarkan informasi tentang layanan yang ditawarkan oleh Penyedia Layanan.
										Jenis layanan yang dapat diminta melalui Aplikasi adalah:
										<ol type="a">
											<li>Kurir Instan;</li>
											<li> Transportasi;</li>
											<li> Pengiriman Makanan;</li>
											<li> Pembelanjaan Pribadi; dan</li>
											<li>
												{' '}
												Layanan lain yang dapat kami tambahkan dari waktu ke waktu ("Layanan").
											</li>
										</ol>
									</li>
                  <li>
									Aplikasi ini memungkinkan Anda untuk mengirimkan permintaan untuk suatu Layanan
									kepada Penyedia Layanan. Penerima GPS - yang harus dipasang pada perangkat bergerak
									(smart phone) dimana Anda telah mengunduh Aplikasi - mendeteksi lokasi Anda dan
									mengirimkan informasi lokasi Anda ke Penyedia Layanan terkait. Penyedia Layanan
									memiliki kebijakan sendiri dan menyeluruh untuk menerima atau menolak setiap
									permintaan Anda atas Layanan. Penyedia Layanan juga memiliki kebijakannya sendiri
									dan menyeluruh untuk memilih dan menerima arahan-arahan yang diberikan oleh Aplikasi
									tersebut. Jika Penyedia Layanan menerima permintaan Anda, Aplikasi akan memberitahu
									Anda dan memberikan informasi mengenai Penyedia Layanan - termasuk nama Penyedia
									Layanan, nomor polisi kendaraannya, dan kemampuan untuk menghubungi Penyedia Layanan
									melalui telepon. Aplikasi ini juga memungkinkan Anda untuk melihat perkembangan
									Penyedia Layanan menjuju titik penjemputan, secara langsung/real time.
									</li>
									<li>
										Kami akan melakukan semua upaya wajar untuk menghubungkan Anda dengan Penyedia
										Layanan untuk mendapatkan Layanan, tergantung kepada keberadaan Penyedia Layanan
										di atau di sekitar lokasi Anda pada saat Anda melakukan pemesanan Layanan.
									</li>
									<li>
										UNTUK MENGHINDARI KERAGU-RAGUAN, KAMI ADALAH PERUSAHAAN TEKNOLOGI, BUKAN
										PERUSAHAAN TRANSPORTASI ATAU KURIR DAN KAMI TIDAK MEMBERIKAN LAYANAN
										TRANSPORTASI ATAU KURIR. Kami tidak mempekerjakan Penyedia Layanan dan kami
										tidak bertanggung jawab atas setiap tindakan dan/atau kelalaian Penyedia
										Layanan. Aplikasi ini hanya merupakan sarana untuk memudahkan pencarian atas
										Layanan. Adalah tergantung pada Penyedia Layanan untuk menawarkan Layanan kepada
										Anda dan tergantung pada Anda apakah Anda akan menerima tawaran Layanan dari
										Penyedia Layanan.
									</li>
								</ol>
								<h5>Ketentuan untuk Menggunakan Aplikasi</h5>
								<ol type="1">
									<li>
										Anda menyatakan dan menjamin bahwa Anda adalah individu yang secara hukum berhak
										untuk mengadakan perjanjian yang mengikat berdasarkan hukum Negara Republik
										Indonesia, khususnya Ketentuan Penggunaan, untuk menggunakan Aplikasi dan bahwa
										Anda telah berusia minimal 17 tahun atau sudah menikah dan tidak berada di bawah
										perwalian. Jika tidak, kami atau Penyedia Layanan terkait, berhak berdasarkan
										hukum untuk membatalkan perjanjian yang dibuat dengan Anda. Anda selanjutnya
										menyatakan dan menjamin bahwa Anda memiliki hak, wewenang dan kapasitas untuk
										menggunakan Layanan Anda juga menyatakan dan menjamin bahwa Anda berwenang untuk
										mengadakan, dan mengikatkan diri entitas tersebut pada Ketentuan Penggunaan ini
										dan mendaftarkan untuk Layanan dan Aplikasi.
									</li>
									<li>
										Kami mengumpulkan dan memproses informasi pribadi Anda, seperti nama, alamat
										surat elektronik (surel / e-mail), dan nomor telepon seluler Anda ketika Anda
										mendaftar. Anda harus memberikan informasi yang akurat dan lengkap,
										memperbaharui informasi dan setuju untuk memberikan kepada kami bukti identitas
										apapun yang secara wajar dapat kami mintakan. Jika informasi pribadi yang Anda
										berikan kepada kami ada yang berubah, misalnya, jika Anda mengubah alamat surel,
										nomor telepon, atau jika Anda ingin membatalkan akun Anda, mohon perbaharui
										rincian informasi Anda dengan mengirimkan permintaan Anda kepada kami. Kami
										akan, sepanjang yang dapat kami lakukan, memberlakukan perubahan yang diminta
										tersebut dalam waktu lima belas (15) hari kerja sejak diterimanya pemberitahuan
										perubahan.
									</li>
									<li>
										Anda hanya dapat menggunakan Aplikasi ketika Anda telah mendaftar pada Aplikasi
										tersebut. Setelah Anda berhasil mendaftarkan diri, Aplikasi akan memberikan Anda
										suatu akun pribadi yang dapat diakses dengan kode verifikasi 4 digit yang kita
										kirim secara acak.
									</li>
									<li>
										Hanya Anda yang dapat menggunakan akun Anda sendiri dan Anda berjanji untuk
										tidak memberikan wewenang kepada orang lain untuk menggunakan identitas Anda
										atau menggunakan akun Anda. Anda tidak dapat menyerahkan atau mengalihkan akun
										Anda kepada pihak lain. Anda harus menjaga keamanan dan kerahasiaan PIN akun
										Anda dan setiap identifikasi yang kami berikan kepada Anda. Dalam hal terjadi
										pengungkapan atas kata sandi Anda, dengan cara apapun, yang mengakibatkan setiap
										penggunaan yang tidak sah atau tanpa kewenangan atas akun atau identitas Anda,
										pesanan yang diterima dari penggunaan yang tidak sah atau tanpa kewenangan
										tersebut masih akan dianggap sebagai pesanan yang sah, kecuali Anda memberitahu
										kami tentang mengenai hal tersebut sebelum Penyedia Layanan memberikan Layanan
										yang diminta.
									</li>
									<li>Anda hanya dapat memiliki satu akun DELIV.</li>
									<li>
										Informasi yang diberikan oleh Aplikasi tidak dapat diartikan sebagai suatu saran
										atau penawaran, keputusan untuk menggunakan Penyedia Layanan sepenuhnya berada
										di tangan Anda. Anda bebas untuk memilih untuk menggunakan penyedia layanan
										lainnya.
									</li>
									<li>
										Anda berjanji bahwa Anda akan menggunakan Aplikasi hanya untuk tujuan yang
										dimaksud untuk mendapatkan Layanan. Anda tidak diperbolehkan untuk
										menyalahgunakan atau menggunakan Aplikasi untuk tujuan penipuan atau menyebabkan
										ketidaknyamanan kepada orang lain atau melakukan pemesanan palsu.
									</li>
									<li>
										Jika Anda juga adalah seorang Penyedia Layanan, Anda tidak dapat menggunakan
										akun konsumen Anda sendiri (atau akun milik konsumen orang lain) untuk melakukan
										pemesanan yang akan Anda terima sendiri sebagai seorang pengemudi.
									</li>
									<li>
										Anda tidak diperkenankan untuk membahayakan, mengubah atau memodifikasi Aplikasi
										dan/atau Situs web atau mencoba untuk membahayakan, mengubah atau memodifikasi
										Aplikasi dan/atau Situs web dengan cara apapun. Kami tidak bertanggungjawab jika
										Anda tidak memiliki perangkat yang sesuai atau jika Anda telah mengunduh versi
										Aplikasi yang salah untuk perangkat Anda. Kami berhak untuk melarang Anda untuk
										menggunakan Aplikasi lebih lanjut jika Anda menggunakan Aplikasi dengan
										perangkat yang tidak kompatibel/cocok atau tidak sah atau untuk tujuan lain
										selain daripada tujuan yang dimaksud untuk penggunaan Aplikasi ini. Anda
										berjanji bahwa Anda hanya akan menggunakan suatu jalur akses yang diperbolehkan
										untuk Anda gunakan.
									</li>
									<li>
										Anda akan menjaga kerahasiaan dan tidak akan menyalahgunakan informasi yang Anda
										terima dari penggunaan Aplikasi tersebut. Anda akan memperlakukan Penyedia
										Layanan dengan hormat dan tidak akan terlibat dalam perilaku atau tindakan yang
										tidak sah, mengancam atau melecehkan ketika menggunakan layanan mereka.
									</li>
									<li>
										Anda memahami dan setuju bahwa penggunaan Aplikasi oleh Anda akan tunduk pula
										pada Kebijakan Privasi kami sebagaimana dapat diubah dari waktu ke waktu. Dengan
										menggunakan Aplikasi, Anda juga memberikan persetujuan sebagaimana
										dipersyaratkan berdasarkan Kebijakan Privasi kami.
									</li>
									<li>
										Dengan memberikan informasi kepada kami, Anda menyatakan bahwa Anda berhak untuk
										memberikan kepada kami informasi yang akan kami gunakan dan berikan kepada
										Penyedia Layanan.
									</li>
									<li>
										Aplikasi tidak boleh dipergunakan untuk mencari Layanan untuk:
										<ol type="a">
											<li>
												mengangkut dan/atau memperoleh dan/atau membeli barang yang dilarang
												oleh pejabat yang berwenang atau barang yang memerlukan lisensi atau
												izin tertentu dari pejabat yang berwenang untuk dikirimkan;
											</li>
											<li>mengangkut barang dari dan ke penjara;</li>
											<li>membeli dan/atau mengangkut binatang peliharaan atau binatang lain;</li>
											<li>
												mengangkut barang-barang dengan dimensi lebih dari 70cm (panjang), 50cm
												(lebar), 50 cm(tinggi) atau barang-barang yang beratnya lebih dari 20kg;
											</li>
											<li>
												membeli dan/atau mengangkut barang-barang ilegal atau berbahaya atau
												barang-barang curian, termasuk namun tidak terbatas pada barang-barang
												yang mengandung bahan berbahaya atau beracun, obat-obatan atau material
												terlarang/ilegal; dan
											</li>
											<li>
												membeli dan/atau mengangkut atau mengirimkan barang-barang berharga atau
												barang yang bernilai lebih dari Rp10.000.000,-
											</li>
										</ol>
									</li>
									<li>
										Anda harus memberikan kepada kami informasi yang akurat dan lengkap mengenai
										jenis, ukuran, spesifikasi dan/atau setiap karakteristik khusus dari makanan
										atau barang yang akan dikirimkan dengan layanan Kurir Instan atau dibeli dengan
										layanan Pengiriman Makanan atau layanan Pembelanjaan Pribadi.
									</li>
								</ol>
							</div>
						</div>
					</div>
				</div>
				<div className="column is-one-quarter section">
					<figure>
						<img src="/img/banner-gopoint-1.jpg" alt="" />
					</figure>
				</div>
			</div>
		);
	}
}

export default Tab2;
